// extracted by css-extract-rspack-plugin
export default {"premium-gallery-icon":"oTzjT4","premiumGalleryIcon":"oTzjT4","watchers-only-icon":"UVwkXi","watchersOnlyIcon":"UVwkXi"};